import * as React from 'react';
import {withNamespaces, WithNamespaces} from "react-i18next";
import {Route} from "react-router";
import BoardTreeView from "../../InspectioBoards/components/BoardTreeView";
import * as Routes from "../../routes";
import Feedback from "./Feedback";
import Logo from "./Logo";
import Organization from "./Organization";
import Search from "./Search";

interface OwnProps {
    collapsed: boolean;
}

type WorkspaceSidebarProps = OwnProps & WithNamespaces;

const WorkspaceSidebar = (props: WorkspaceSidebarProps) => {
    return <>
        {!props.collapsed && <Logo collapsed={props.collapsed} />}
        {!props.collapsed && <Organization />}
        <div className="item">
            <div id="boardSidebarContainer" />
        </div>
        {!props.collapsed && <>
            <Search />
            <Route exact={true} path={Routes.inspectioBoardWorkspace} component={BoardTreeView} />
            <Feedback/>
        </>}
    </>;
};

export default withNamespaces()(WorkspaceSidebar);
